import { render } from "./ApprovalPanel.vue?vue&type=template&id=7bf44c5e"
import script from "./ApprovalPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__